import React from 'react';

/**
 * Hero photo wrapper with logo pill on top. Renders either:
 *  - the actual <img> (when a resolved URL is available and load did not fail), or
 *  - a placeholder block ("No photo available").
 *
 * Per-car cropping is supported via `car.imagePosition` (e.g. "30% 15%").
 * If absent, falls back to `object-position` from CSS.
 *
 * @param {object} props
 * @param {object} props.car — Car object (DealerCarDto).
 * @param {string} props.imageUrl — resolved image URL (imgproxy or raw).
 * @param {boolean} props.imgFailed — true when the <img> fired onError.
 * @param {() => void} props.onImgError — handler bumped to parent so it
 *   can flip imgFailed and switch to the placeholder.
 * @param {string} props.title — alt text (display title of the car).
 */
// Memoized — props are stable: `car` and `imageUrl` come from parent state
// that only changes per car, `onImgError` is wrapped in useCallback in
// NewModelLanding so identity is stable. См. discussion на MR #787.
const HeroPhoto = React.memo(function HeroPhoto({ car, imageUrl, imgFailed, onImgError, title }) {
  const showPlaceholder = !imageUrl || imgFailed;

  return (
    <div className="landing__photo-wrapper">
      {!showPlaceholder && (
        <img
          className="landing__photo"
          src={imageUrl}
          alt={title}
          onError={onImgError}
          style={car.imagePosition ? { objectPosition: car.imagePosition } : undefined}
        />
      )}
      {showPlaceholder && (
        <div className="landing__photo-placeholder">
          <span className="landing__photo-placeholder-text">No photo available</span>
        </div>
      )}
    </div>
  );
});

export default HeroPhoto;
